import API_URLS from './URLS';

const VISIT_TYPE_LINKS = {
  1: API_URLS.assessments,
  2: API_URLS.enforcement,
  3: API_URLS.education,
};

export default VISIT_TYPE_LINKS;
